import { render, staticRenderFns } from "./ProjectSettlementPricing.vue?vue&type=template&id=cd53666c&scoped=true"
import script from "./ProjectSettlementPricing.vue?vue&type=script&lang=js"
export * from "./ProjectSettlementPricing.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettlementPricing.vue?vue&type=style&index=0&id=cd53666c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd53666c",
  null
  
)

export default component.exports